export default __webpack_public_path__ + "static/media/contact.db9e1406.svg";